import { render, staticRenderFns } from "./AreaEmbargadaSemaMt.vue?vue&type=template&id=6871d040&lang=pug"
import script from "./AreaEmbargadaSemaMt.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaSemaMt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports